module.exports = __webpack_public_path__ + "static/media/arrow-r.44213325.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/icon/arrow-r.svg
// module id = 90
// module chunks = 0